module.exports = __webpack_public_path__ + "img/m8-ebay.cd49cd17.png";